import { ApiResponse, postJson } from './Apis';

export type RegisterPostModel = {
    Username: string,
    Email: string,
    EmailConfirmation: string,
    Password: string,
    PasswordConfirm: string
}

export type RegisterResponseModel = {
    Errors: string[]
}

export async function API_Register(data: RegisterPostModel): Promise<ApiResponse<RegisterResponseModel>> {
    return await postJson<ApiResponse<RegisterResponseModel>>("webapi/candidate/user/Register", data);
}
